import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

type UseSkillInput = { skill?: string };

function UseSkillHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const skillName = (toolUse.input as UseSkillInput | undefined)?.skill;
  const done = !!result && !result.isError;
  const text = skillName
    ? done
      ? `Noodled ${skillName}`
      : `Noodling ${skillName}…`
    : done
      ? "Noodled skill"
      : "Noodling skill…";
  return (
    <ToolStatus
      icon="graduation-cap"
      text={text}
      pending={!done && !interrupted}
    />
  );
}

function UseSkillBody({ toolUse, result }: ToolUseProps) {
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(toolUse.input, null, 2)}
      </pre>
      {result && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {JSON.stringify(result.output, null, 2)}
        </pre>
      )}
    </Text>
  );
}

export const useSkill: ChatTool = {
  name: "useSkill",
  Header: UseSkillHeader,
  Body: UseSkillBody,
};

export const readSkillFile: ChatTool = {
  name: "readSkillFile",
  Header: ({ result, interrupted }) => (
    <ToolStatus
      icon="notebook-text"
      text={
        result && !result.isError ? "Read skill file" : "Reading skill file…"
      }
      pending={!result && !interrupted}
    />
  ),
  Body: UseSkillBody,
};

export const runSkillScript: ChatTool = {
  name: "runSkillScript",
  Header: ({ result, interrupted }) => (
    <ToolStatus
      icon="code"
      text={
        result && !result.isError ? "Ran skill script" : "Running skill script…"
      }
      pending={!result && !interrupted}
    />
  ),
  Body: UseSkillBody,
};
